import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { SidebarModule } from "primeng/sidebar";
import { CheckboxModule } from "primeng/checkbox";
import { InputTextModule } from "primeng/inputtext";
import { DashboardRoutingModule } from "../dashboard/dashboard-routing.module";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { TableModule } from "primeng/table";
import { LoaderWrapperModule } from "../loader-wrapper/loader-wrapper.module";
import { TooltipModule } from "primeng/tooltip";
import { RadioButtonModule } from "primeng/radiobutton";
import { FileUploadModule } from "primeng/fileupload";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { BrowserModule } from "@angular/platform-browser";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { InputMaskModule } from "primeng/inputmask";
import { AutoCompleteModule } from "primeng/autocomplete";
import { PaginatorModule } from "primeng/paginator";
import { SharedModule } from "../shared/shared.module";
import { SupportModule } from "../support/support.module";
import { DialogModule } from "primeng/dialog";
import { FooterModule } from "../core/footer/footer.module";
import { CalendarModule } from "primeng/calendar";
import {TotpSetupComponent} from "./totp-setup.component";

@NgModule({
  declarations: [TotpSetupComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    SidebarModule,
    CheckboxModule,
    InputTextModule,
    DashboardRoutingModule,
    DropdownModule,
    MultiSelectModule,
    TableModule,
    LoaderWrapperModule,
    TooltipModule,
    RadioButtonModule,
    FileUploadModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    BrowserModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    InputMaskModule,
    AutoCompleteModule,
    PaginatorModule,
    SharedModule,
    SupportModule,
    DialogModule,
    FooterModule,
    CalendarModule,
  ],
  exports: [SidebarModule],
  providers: [ConfirmationService],
})
export class TotpSetupModule {

}
